import script from "./MaterialInfoFields.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialInfoFields.vue?vue&type=script&setup=true&lang=js"

import "./MaterialInfoFields.vue?vue&type=style&index=0&id=5d4c9df5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d4c9df5"]])

export default __exports__